<template>
  <div id="shopStep" class="container">
    <div class="p-booking__inner-wrapper">
      <div class="p-booking__title pt-4" :class="{ 'mb-3': store.shopBanner }">
        {{ dictionary.someSnacks }}
      </div>

      <!-- Banner -->
      <div v-if="store.shopBanner" class="p-booking__banner">
        <a
          v-if="store.shopBanner.url"
          :href="store.shopBanner.url"
          target="_blank"
          rel="noopener noreferrer">
          <picture>
            <source
              v-if="store.shopBanner.mobile"
              :srcset="store.shopBanner.mobile.src"
              :media="`(max-width: 768px)`" />
            <img
              v-if="store.shopBanner.desktop"
              :src="store.shopBanner.desktop.src"
              :alt="store.shopBanner.desktop.alt || 'Special Offer'" />
          </picture>
        </a>
        <picture v-else>
          <source
            v-if="store.shopBanner.mobile"
            :srcset="store.shopBanner.mobile.src"
            :media="`(max-width: 768px)`" />
          <img
            v-if="store.shopBanner.desktop"
            :src="store.shopBanner.desktop.src"
            :alt="store.shopBanner.desktop.alt || 'Special Offer'" />
        </picture>
      </div>

      <div class="p-booking__tickets-wrapper">
        <div class="p-booking__tickets-choice">
          <ShopItems
            v-if="sortedProduct.length"
            class="mt-3"
            :shope-items="sortedProduct">
            <template #remove="{ product }">
              <button
                :key="selectedProducts[product.id]"
                type="button"
                class="btn-icon btn--minus-icon"
                :disabled="store.getSelectedProductCounter(product) === 0"
                @click="() => store.removeUserProduct(product)"></button>
            </template>
            <template #counter="{ product }">
              {{ store.getSelectedProductCounter(product) }}
            </template>
            <template #add="{ product }">
              <button
                class="btn-icon btn-plus-icon"
                type="button"
                :disabled="isDisabledAdd(product)"
                @click="() => store.addNewUserProduct(product)"></button>
            </template>
          </ShopItems>
        </div>

        <div class="p-booking__tickets-total">
          <div class="p-booking__shop__summary mt-3">
            <CartSummary />

            <CartPoints v-if="store.getUserPoints > 0"></CartPoints>

            <div class="p-booking__shop__warning">
              {{ dictionary.glutenWarning }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, getCurrentInstance, ref } from 'vue'
import ShopItems from '../../components/Booking/Step4/ShopItems.vue'
import CartSummary from '../../components/Booking/Shared/CartSummary.vue'
import CartPoints from '../../components/Booking/Shared/CartPoints.vue'
import { useBookingStore } from '../../store/BookingStore'
const store = useBookingStore()

const { configuration, dictionary } =
  getCurrentInstance().appContext.config.globalProperties

const selectedProducts = ref(store.getAllSelectedProducts)

const isDisabledAdd = (item) => {
  const availablePoints = store.checkAvailablePoints(item.points) //true
  const { maxItemsPerProduct } = configuration
  return (
    store.getSelectedProductCounter(item) >= maxItemsPerProduct ||
    !availablePoints
  )
}

const sortedProduct = computed(() => {
  // sort groups by groupId
  const sorted = [...store.shopItems].sort(
    (a, b) => a.values[0].groupId - b.values[0].groupId,
  )

  // sort products by sortOrder
  sorted.forEach((item) => {
    item.values.sort((a, b) => a.sortOrder - b.sortOrder)
  })

  return sorted
})
</script>
